import React, { useEffect, useState } from "react";
import { getFoodItems, addFood, updateFood, deleteFood, uploadFoodImage, IMAGE_URL } from "../api/api";
import "../styles/Products.css";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [productData, setProductData] = useState({
    id: null,
    name: "",
    price: "",
    description: "",
    image: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [uploadMessage, setUploadMessage] = useState("");

  // Fetch products on mount and after any changes
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await getFoodItems();
      if (Array.isArray(response.data)) {
        setProducts(response.data);
      } else {
        setProducts([]);
        console.error("Unexpected response:", response.data);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Error fetching products");
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    setProductData({ ...productData, [e.target.name]: e.target.value });
  };

  // Handle file change for image upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const response = await uploadFoodImage(file);
        if (response.data.filename) {
          setProductData((prev) => ({ ...prev, image: response.data.filename }));
          setUploadMessage("Image uploaded successfully.");
        } else {
          setUploadMessage(response.data.error || "Upload failed.");
        }
      } catch (err) {
        console.error("Error uploading image:", err);
        setUploadMessage("Image upload failed.");
      }
    }
  };

  // Handle Add or Update product submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (productData.id) {
        // Update existing product
        response = await updateFood(productData);
        setMessage(response.data.message || "Product updated successfully");
      } else {
        // Add new product
        response = await addFood(productData);
        setMessage(response.data.message || "Product added successfully");
      }
      setProductData({ id: null, name: "", price: "", description:"", image: "" });
      fetchProducts();
    } catch (err) {
      console.error("Error submitting product:", err);
      setError("Failed to submit product.");
    }
  };

  // Handle product edit: populate form with product data
  const handleEdit = (product) => {
    setProductData({
      id: product.id,
      name: product.name,
      price: product.price,
      description: product.description,
      image: product.image
    });
    setMessage("");
    setError("");
    setUploadMessage("");
  };

  // Handle product deletion
  const handleDelete = async (productId) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    try {
      const response = await deleteFood({ id: productId });
      setMessage(response.data.message || "Product deleted successfully");
      fetchProducts();
    } catch (err) {
      console.error("Error deleting product:", err);
      setError("Failed to delete product.");
    }
  };

  return (
    <div className="products-container">
      <h2>Manage Products</h2>
      {message && <p className="message">{message}</p>}
      {error && <p className="error">{error}</p>}
      {uploadMessage && <p className="upload-message">{uploadMessage}</p>}

      <div className="product-form-container">
        <h3>{productData.id ? "Edit Product" : "Add New Product"}</h3>
        <form onSubmit={handleSubmit} className="product-form">
          <input
            type="text"
            name="name"
            placeholder="Product Name"
            value={productData.name}
            onChange={handleChange}
            required
          />
          <input
            type="number"
            step="0.01"
            name="price"
            placeholder="Price"
            value={productData.price}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="description"
            placeholder="Product Description"
            value={productData.description}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="image"
            placeholder="Image Filename"
            value={productData.image}
            onChange={handleChange}
            readOnly
          />
          <input type="file" accept="image/*" onChange={handleFileChange} />
          <button type="submit" className="product-btn">
            {productData.id ? "Update Product" : "Add Product"}
          </button>
        </form>
      </div>

      <div className="products-grid">
        {products.length === 0 ? (
          <p>No products found.</p>
        ) : (
          products.map((product) => (
            <div key={product.id} className="product-card">
              <img
                src={`${IMAGE_URL}${product.image}`}
                alt={product.name}
              />
              <div className="product-info">
                <h3>{product.name}</h3>

                {product.description && (
           <p className="product-desc">
             {product.description.length > 100
               ? product.description.substring(0, 100) + "…"
               : product.description}
           </p>
         )}

                <p>&#8377;{Number(product.price).toFixed(2)}</p>

              </div>
              <div className="product-actions">
                <button className="product-btn edit-btn" onClick={() => handleEdit(product)}>
                  Edit
                </button>
                <button className="product-btn delete-btn" onClick={() => handleDelete(product.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Products;
